export default function getQueryString(qs) {
  const obj = Object.create(null);

  if (!qs) return obj;

  // Remove any leading ?, #, or &
  qs = qs.trim().replace(/^(\?|#|&)/, '');
  qs = qs.split('&');

  qs.forEach(p => {
    const [key, value] = p.split('=').map(decodeURIComponent);

    if (!obj[key]) {
      obj[key] = value;
    } else {
      if (!Array.isArray(obj[key])) {
        obj[key] = [obj[key]];
      }

      obj[key].push(value);
    }
  });

  return obj;
}



// WEBPACK FOOTER //
// ./utils/get-query-string.js